import { Component, computed, inject, output } from '@angular/core';
import { SignalsStoreService } from '../signals-store.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { SidebarService } from './sidebar.service';
import { SidebarMenu } from './sidebar.types';
import { CommonModule } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { CategorySelected } from '../types/common.types';
import { ProductsService } from '../../product/products.service';
import { ResolutionService } from '../resolution.service';
import { goToTopPage } from '../common/utils';
import { ShopComponent } from '../../shop/shop.component';

@Component({
  selector: 'app-sidebar',
  imports: [MatCheckboxModule, FormsModule, CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {

  //#region Services

  signalsStore = inject(SignalsStoreService);

  sidebarService = inject(SidebarService);

  #resolutionService = inject(ResolutionService);

  #productsService = inject(ProductsService);

  //#endregion

  //#region Properties

  hasGlobalMessages = computed(() => !!this.signalsStore.globalMessages().length);

  isMobile = computed(() => this.#resolutionService.isMobile());

  //#endregion

  //#region Constructor

  outIsMenuReady = output<boolean>();

  constructor(public shopComponent: ShopComponent) {
    toObservable(this.sidebarService.sidebar).subscribe((res) => {
      if (!res || res.length === 0) return;
      setTimeout(() => {
        this.outIsMenuReady.emit(true);
      }, 100);
    });

    toObservable(this.signalsStore.categoryInViewPort)
      .subscribe(obs => this.#changeCategoryInViewPort(obs));
  }


  //#endregion

  //#region Methods

  goToShopSection(item: SidebarMenu, event: Event) {
    this.#productsService.goToSection(item, event);
  }

  #changeCategoryInViewPort(obj: CategorySelected | null) {

    const { categoryId, subCategoryId, subCategorySonId } = obj ?? {};

    if (!categoryId || !subCategoryId)
      return;

    this.#resetOpenDetails();
    this.#selectSubCategory([categoryId, subCategoryId, subCategorySonId ?? 0], this.sidebarService.sidebarMenu());
  }

  #resetOpenDetails() {

    const f = (item: SidebarMenu) => {
      item.checked = false;
      if (item.sublist?.length)
        item.sublist.forEach(x => f(x))
    }

    this.sidebarService
      .sidebarMenu()
      .forEach(x => f(x));
  }

  #selectSubCategory(ids: number[], array: SidebarMenu[]) {

    const id = ids.shift();
    const item = array.find(x => x.id === id);

    if (!item)
      return;

    item.checked = true;

    if (!item.sublist?.length)
      return;

    this.#selectSubCategory(ids, item.sublist);
  }

  toggleSidebar() {
    this.signalsStore.isSidebarOpen.update(currentValue => !currentValue);
  }

  goToTop() { goToTopPage() };

  //#endregion
}
